import { createFileRoute } from '@tanstack/react-router'
import JobsPage from '../components/jobs/JobsPage'

export const Route = createFileRoute('/_a/jobs')({
  component: JobsPage,
})
